import { ScanConfigType } from '../Scan';
import { FormViewModel } from './Models';
import RootForm from './RootForm.';
import useDynamicForm from './useDynamicForm';
import { DynamicFormPartType } from './Types';

export type FileInfoType = {
	key: string;
	title: string;
	files: FileList;
	size?: number;
};

export type FormAttachmentInfoType = {
	key: string;
	title: string;
	fileName: string | null;
};

type DataObjectType = {
	values: any;
	fileInfos: Array<FileInfoType>;
	formAttachments: Array<FormAttachmentInfoType>;
	simpleData?: string;
};

export type PageDescriptionType = {
	index: number;
	title: string;
	status:
		'' | 'skip' | 'complete' | 'error' | 'disable' | 'inWork' | 'hidden';
};

export type DynamicFormStateType = {
	loaded: boolean;
	rootModel?: FormViewModel;
	pages: Array<PageDescriptionType>;
	data: any;
	fileInfos: Array<FileInfoType>;
};

export type InitializeObjectType = {
	fileId: string;
	componentId: string;
	typename: string;
	projectSuffix: string;
	formDescription: DynamicFormPartType;
	formContextData: string;
	dataContext: string;
	attachmentsWithSizes?: Record<string, string | number>;
	scanSettings: ScanConfigType;
};

export type useDynamicFormHandlerType = () => {
	initForm: (
		param: InitializeObjectType,
		readOnly: boolean,
	) => Promise<string>;
	formState: DynamicFormStateType;
	formValidate: (pageIndex?: number, validateAll?: boolean) => boolean;
	collectFormDataKoVm: (withSimpleData: boolean) => DataObjectType | null;
	resetForm: () => void;
	isOpalReady: boolean;
};

export type DataCollectObjectType = DataObjectType | null;

export { useDynamicForm };
export default RootForm;
